<template>
  <div class="dwp-relative dwp-inline-block dwp-text-left">
    <div class="dwp-cursor-pointer dwp-select-none" ref="target">
      <slot />
    </div>

    <!--
    Dropdown panel, show/hide based on dropdown state.

    Entering: "transition ease-out duration-100"
      From: "transform opacity-0 scale-95"
      To: "transform opacity-100 scale-100"
    Leaving: "transition ease-in duration-75"
      From: "transform opacity-100 scale-100"
      To: "transform opacity-0 scale-95"
    -->
    <transition
      enter-active-class="dwp-transition dwp-ease-out dwp-duration-100"
      enter-class="dwp-transform dwp-opacity-0 dwp-scale-95"
      enter-to-class="dwp-transform dwp-opacity-100 dwp-scale-100"
      leave-active-class="dwp-transition dwp-ease-in dwp-duration-75"
      leave-class="dwp-transform dwp-opacity-100 dwp-scale-100"
      leave-to-class="dwp-transform dwp-opacity-0 dwp-scale-95"
    >
      <div
        v-if="isOpen && $slots.list"
        ref="dropdown"
        class="dwp-mt-2 dwp-rounded-md dwp-shadow-lg dwp-z-40"
        :class="[positionClass,widthClass,fixedClass]"
      >
        <div class="dwp-rounded-sm dwp-bg-white dwp-shadow-xs">
          <slot name="list" />
        </div>
      </div>
    </transition>

    <div
      class="dwp-fixed dwp-top-0 dwp-left-0 dwp-right-0 dwp-bottom-0"
      ref="overlay"
      v-if="isOpen && fixed"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    open: Boolean,
    position: String,
    fixed: Boolean,
    widthClass: {
      type: String,
      default: "dwp-w-40",
    },
  },

  data() {
    return {
      dropdown: null,
    };
  },

  mounted() {
    jQuery(this.$el).closest("body").on("click touchstart", this.outsideClick);
  },

  beforeDestroy() {
    jQuery(this.$el).closest("body").off("click touchstart", this.outsideClick);
  },

  computed: {
    isOpen: {
      get() {
        return this.open;
      },
      set(val) {
        this.$emit("update:open", val);
      },
    },

    positionClass() {
      switch (this.position) {
        case "right":
          return "dwp-origin-top-right dwp-right-0";
          break;
        case "left":
          return "dwp-origin-top-left dwp-left-0";
          break;
        default:
          return "dwp-origin-top dwp-left-0";
          break;
      }
    },

    fixedClass() {
      return this.fixed ? "dwp-fixed" : "dwp-absolute";
    },
  },

  watch: {
    isOpen(val) {
      if (!this.fixed) {
        return;
      }
      if (val) {
        this.$nextTick(() => {
          this.dropdown = jQuery(this.$refs.dropdown);
          this.overlay = jQuery(this.$refs.overlay);
          jQuery("#dwp--wrapper").contents().find("body").append(this.overlay);
          jQuery("#dwp--wrapper").contents().find("body").append(this.dropdown);

          this.doPosition();
          setTimeout(() => {
            this.doPosition();
          }, 200);
          jQuery(window).on("scroll resize", this.doPosition);

          jQuery("#dwp--wrapper")
            .contents()
            .find(".dwp-overflow-auto")
            .on("scroll", this.doPosition);
        });
      } else {
        this?.dropdown?.remove();
      }
    },
  },

  methods: {
    doPosition() {
      let rect = this?.$refs?.target?.getBoundingClientRect();
      let offset = 0;

      if (this.position == "right") {
        offset = this.dropdown.outerWidth() - rect.width;
      }

      let dropRect = this.dropdown.get(0).getBoundingClientRect();
      let bottomOffset = Math.min(
        0,
        window.innerHeight - (rect.top + 20 + dropRect.height)
      );
      let leftOffset = 0;

      if (bottomOffset < 0) {
        leftOffset = -(this.$refs.target.clientWidth + 10);
      }

      this?.dropdown?.css({
        left: rect.x - offset + leftOffset,
        top: rect.y + 20 + bottomOffset,
      });
    },

    outsideClick(e) {
      e.stopPropagation();
      if (this?.dropdown?.length && this?.dropdown?.get(0).contains(e.target)) {
        return;
      }
      if (this.$el.contains(e.target)) {
        return;
      }
      this.isOpen = false;
    },
  },
};
</script>